export const environment = {
  production: true,
  version: '0.2.3',
  appName: 'Delher - Admin',
  branchName: 'DEVELOPER',
  apiUrl: 'https://dev.api.delher.cloud',
  wsUrl: 'https://dev.api.delher.cloud',
  timezone: 'America/Mexico_City',
  locale: 'en',
  assets: {
    DEFAULT_USER_IMAGE: 'https://dev.api.delher.cloud/uploads/users/_DEFAULT.png',
    DEFAULT_VEHICLE_IMAGE: 'https://dev.api.delher.cloud/uploads/vehicles/_DEFAULT.png',
    DEFAULT_VEHICLE_TYPE_IMAGE: 'https://dev.api.delher.cloud/uploads/vehicles_types/_DEFAULT.png'
  }
};   
